import {
  EmailCourseSignupSuccessModal,
  MailSignupFailModal,
  handleEmailSubmit,
  validateMailAddress,
} from "./utils"
import React, { useEffect, useState } from "react"

import { EnvelopeClosedIcon } from "components/page-components/Icons/small"

export const EmailkursSignup = ({ ressort, course }) => {
  const [mailAddress, setMailAddress] = useState("")
  const updateMailaddress = (e) => setMailAddress(e.target.value)
  const [validEmail, setValidEmail] = useState(false)
  const [successModalClass, setSuccessModalClass] = useState("")
  const [failModalClass, setFailModalClass] = useState("")

  const [checkboxDatenschutz, setCheckboxDatenschutz] = useState(false)
  const toggleDatenschutzCheckbox = (e) => {
    e.target.tagName !== "A" && e.preventDefault()
    setCheckboxDatenschutz(!checkboxDatenschutz)
  }
  const [checkboxMarketing, setcheckboxMarketing] = useState(false)
  const toggleDatenschutzMarketing = (e) => {
    e.target.tagName !== "A" && e.preventDefault()
    setcheckboxMarketing(!checkboxMarketing)
  }
  const [buttonLoading, setButtonLoading] = useState(false)

  const handleSubmit = () => {
    setButtonLoading(true)
    handleEmailSubmit({
      list: course,
      email: mailAddress,
      "marketing-optin": checkboxMarketing,
      launchModal,
    })
  }

  const launchModal = (success) => {
    success ? setSuccessModalClass("is-active") : setFailModalClass("is-active")
  }

  useEffect(() => {
    setValidEmail(validateMailAddress(mailAddress))
  }, [mailAddress])

  return (
    <React.Fragment>
      <div data-nosnippet className="columns is-gapless mt-6 is-centered">
        <div className="column is-two-thirds">
          <div className="control has-icons-left">
            <input
              className="input"
              aria-label="E-Mail-Kurs"
              type="text"
              placeholder="Email (z.B. mustermann@mail.de)"
              onChange={updateMailaddress}
            />

            <span className="icon is-medium is-left">
              <EnvelopeClosedIcon {...{ color: "#b3cbd4" }} />
            </span>
          </div>
        </div>
        <div className="column ">
          <button
            className={`button is-sonnengelb is-fullwidth ${
              buttonLoading ? "is-loading" : ""
            }`}
            disabled={!validEmail || !checkboxDatenschutz}
            onClick={handleSubmit}
          >
            <b>Jetzt anmelden</b>
          </button>
        </div>
      </div>

      <div
        data-nosnippet
        className="columns is-centered is-multiline is-gapless signup-checkboxes "
        style={{
          transition: `.2s ease`,
          maxHeight: validEmail ? "310px" : "0px",
          opacity: validEmail ? "1" : "0",
          visibility: validEmail ? "visible" : "hidden",
        }}
      >
        <div
          onClick={toggleDatenschutzCheckbox}
          onKeyPress={() => {}}
          role="button"
          tabIndex="-1"
          aria-label="Select Datenschutzbestimmungen"
          className="column is-full"
        >
          <input
            type="checkbox"
            id="datenschutzCheckbox"
            name="datenschutzCheckbox"
            onChange={() => {}}
            checked={checkboxDatenschutz}
          />
          <label htmlFor="datenschutzCheckbox">
            <span className="pl-3 has-text-white">
              Ich akzeptiere die Bestimmungen zum{" "}
              <a
                href={"/datenschutzerklaerung"}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "white",
                }}
                className="link"
              >
                Datenschutz
              </a>
              .
            </span>
          </label>
        </div>

        <div
          onClick={toggleDatenschutzMarketing}
          onKeyPress={() => {}}
          role="button"
          tabIndex="-1"
          aria-label="Select Marketinginformationen"
          className="column is-full"
        >
          <input
            type="checkbox"
            id="marketingCheckbox"
            name="marketingCheckbox"
            onChange={() => {}}
            checked={checkboxMarketing}
          />
          <label htmlFor="marketingCheckbox">
            <span className="pl-3 has-text-white">
              Ja ich möchte die für mich zugeschnittenen Marketinginformationen
              durch die B_I MEDIEN GmbH erhalten und erteile die{" "}
              <a
                href={"/marketing-einwilligung"}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "white",
                }}
                className="link"
              >
                hier detailliert beschriebene Einwilligung
              </a>
              .
            </span>
          </label>
        </div>
      </div>

      <EmailCourseSignupSuccessModal
        {...{
          ressort,
          successModalClass,
          setButtonLoading,
          setSuccessModalClass,
        }}
      />

      <MailSignupFailModal
        {...{
          ressort,
          failModalClass,
          setButtonLoading,
          setFailModalClass,
        }}
      />
    </React.Fragment>
  )
}
